import { EOriginSystemId } from '@if/core/types'
import { Typography } from '@mui/material'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'
import AddChangeCoappButton from '../AddCoappButton'
import CancelCreditAppButton from '../CancelCreditAppButton'

interface Props {
  creditApp: CreditApplication
}

const PrequalDeclined = ({ creditApp }: Props) => {
  const { t } = useTranslation()
  const { id, financingProgramId, coApplicant, originSystemId } = creditApp
  const hasMerchantDashboardOrigin = originSystemId === EOriginSystemId.MerchantDashboard

  return (
    <>
      <Typography variant="body1">{t('viewCreditApplication.clientDeclined')}</Typography>

      {!hasMerchantDashboardOrigin && (
        <>
          {!coApplicant ? (
            <Typography variant="body1">{t('viewCreditApplication.applicantAddCoappInvite')}</Typography>
          ) : (
            <Typography variant="body1">{t('viewCreditApplication.applicantUpdateCoappInvite')}</Typography>
          )}
        </>
      )}

      {hasMerchantDashboardOrigin && (
        <>
          <AddChangeCoappButton
            id={id!}
            financingProgramId={financingProgramId}
            coapp={coApplicant}
            isHardDecline={creditApp.finalCreditDecision?.isHardDecline}
          />
          <CancelCreditAppButton creditApp={creditApp} />
        </>
      )}
    </>
  )
}

export default PrequalDeclined
